/* =========================================================
   KXO — trust modal (portal to body + robust open/close)
   Fixes "modal stuck in right column" caused by transformed parents.
   ========================================================= */

(() => {
  const OPEN_SEL  = '[data-kxo-trust-open]';
  const CLOSE_SEL = '[data-kxo-trust-close]';

  const MODAL_SEL = '.kxo-trust-modal';
  const OPEN_CLASS = 'is-open';

  const lockScroll = (lock) => {
    document.documentElement.classList.toggle('kxo-modal-open', !!lock);
    document.body.classList.toggle('kxo-modal-open', !!lock);
  };

  // --- Portal: move every modal to <body> so position:fixed is viewport-based
  const portalAllModalsToBody = () => {
    document.querySelectorAll(MODAL_SEL).forEach((modal) => {
      if (modal.dataset.kxoPortaled === '1') return;
      modal.dataset.kxoPortaled = '1';
      document.body.appendChild(modal);
    });
  };

  const getOpenModal = () => document.querySelector(`${MODAL_SEL}.${OPEN_CLASS}`);

  const openModalById = (id, openerEl) => {
    if (!id) return;

    portalAllModalsToBody();

    const modal = document.getElementById(id);
    if (!modal) return;

    // close any other open modal
    const already = getOpenModal();
    if (already && already !== modal) closeModal(already);

    modal.__kxoOpener = openerEl || null;

    modal.classList.add(OPEN_CLASS);
    modal.setAttribute('aria-hidden', 'false');

    lockScroll(true);

    // focus close button first (best a11y + reliable)
    const focusTarget =
      modal.querySelector(CLOSE_SEL) ||
      modal.querySelector('.kxo-trust-modal__panel') ||
      modal;

    // wait a tick so CSS display/grid applies
    requestAnimationFrame(() => {
      try { focusTarget.focus?.({ preventScroll: true }); } catch {}
    });
  };

  const closeModal = (modal) => {
    if (!modal) return;

    modal.classList.remove(OPEN_CLASS);
    modal.setAttribute('aria-hidden', 'true');

    lockScroll(false);

    // restore focus to opener if possible
    const opener = modal.__kxoOpener;
    modal.__kxoOpener = null;
    if (opener && document.contains(opener)) {
      requestAnimationFrame(() => {
        try { opener.focus?.({ preventScroll: true }); } catch {}
      });
    }
  };

  // --- Events
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest(OPEN_SEL);
    if (openBtn) {
      e.preventDefault();
      openModalById(openBtn.getAttribute('aria-controls'), openBtn);
      return;
    }

    const closeBtn = e.target.closest(CLOSE_SEL);
    if (closeBtn) {
      e.preventDefault();
      closeModal(closeBtn.closest(MODAL_SEL));
      return;
    }

    // click on overlay closes
    const overlay = e.target.closest('.kxo-trust-modal__overlay');
    if (overlay) {
      e.preventDefault();
      closeModal(overlay.closest(MODAL_SEL));
      return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const modal = getOpenModal();
    if (modal) closeModal(modal);
  });

  // --- Boot + Shopify editor re-renders
  const boot = () => portalAllModalsToBody();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
